<template>
  <div class="px-4 py-4">
    <div v-if="meta.version == '1' || meta.version == '2' || meta.version=='ext1'">
        <p>
          The log<sub>2</sub>fold-change and viability values relative to the negative control for each cell line at each dose are presented in the table and heatmap.
          <br><br>
          Lower viability scores indicate more killing (higher sensitivity), while higher viability scores indicate less killing (lower sensitivity).
        </p>
    </div>
  </div>
</template>

<script>
import * as portalContent from '@/js/models/portal-content.js';
export default {
  name: 'viability-heatmap-drawer',
  // props: {
  //   version: Number
  // },
  data: () => ({

  }),
  computed:{
    meta(){
          const section_id = "viability-heatmap";
          const screen = this.$route.params.screen;
          const version_meta = portalContent.getVersionMetadata(screen, section_id);
          return version_meta
        }
  },
  mounted() {

  },
  methods: {},
  watch: {}
}
</script>

<style scoped>


</style>
